import { render, staticRenderFns } from "./crossSales.vue?vue&type=template&id=837cc5ee"
import script from "./crossSales.vue?vue&type=script&lang=js"
export * from "./crossSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports